import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ProcurementCategoriesTable from '../procurement_categories/ProcurementCategoriesTable';

import ProcurementPoliciesTable from './ProcurementPoliciesTable';

const queryParams = new URLSearchParams(window.location.search);
const query = { subTab: queryParams.get('sub_tab') };

function ProcurementPoliciesIndex(props) {
    return (
        <div>
            <div className="tw-flex tw-flex-col tw-gap-6">
                <div
                    className="in-nav horizontal"
                    data-tabs-active-classes="active"
                    data-tabs-inactive-classes="inactive"
                    data-default-tab-id="procurement-policies-tab"
                    data-tabs-toggle="#procurement-policies-tab-content"
                    role="tablist"
                >
                    <button
                        className="in-nav__item"
                        id="procurement-policies-tab"
                        data-tabs-target="#procurement-policies"
                        type="button"
                        role="tab"
                        aria-controls="procurement-policies"
                        aria-selected="true"
                    >
                        {$t('Policies')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="procurement-categories-tab"
                        data-tabs-target="#procurement-categories"
                        type="button"
                        role="tab"
                        aria-controls="procurement-categories"
                        aria-selected="false"
                    >
                        {$t('Categories')}
                    </button>
                </div>

                <div id="procurement-policies-tab-content">
                    <div id="procurement-policies" role="tabpanel" aria-labelledby="procurement-policies-tab">
                        <ProcurementPoliciesTable
                            indexUrl={policiesIndexUrl}
                            createUrl={policiesCreateUrl}
                            updateUrl={policiesUpdateUrl}
                            deleteUrl={policiesDeleteUrl}
                        />
                    </div>
                    <div id="procurement-categories" role="tabpanel" aria-labelledby="procurement-categories-tab">
                        <ProcurementCategoriesTable
                            indexUrl={categoriesIndexUrl}
                            updateUrl={categoriesUpdateUrl}
                            createUrl={categoriesCreateUrl}
                            deleteUrl={categoriesDeleteUrl}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProcurementPoliciesIndex;

if (document.getElementById('procurementPoliciesIndex')) {
    var root = document.getElementById('procurementPoliciesIndex');
    ReactDOM.render(
        <App>
            <ProcurementPoliciesIndex />
        </App>,
        root,
    );
}
